import React from 'react'
import IconBase from 'react-components/atoms/IconBase/IconBase'

function Minus({ className }) {
  return (
    <IconBase name="minus" w={12} className={className}>
      <line
        x1="1"
        y1="6"
        x2="11"
        y2="6"
        className="strokeme"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
    </IconBase>
  )
}

export default Minus
